import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, PartnerBenefitCardType, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile, isPartnerAffiliated, setAppHeader } from "../../configs/utils";
import { ACTION } from "./types";
import { getStartedAction } from "./actions";
import { heightMap } from "../../configs/height";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
const _isMobile = isMobile();
export const template = async (refCode, referredPartner, partnerAccountType) => ({
    layout: {
        id: ROUTE.EMPANEL_SUCCESS_MODAL,
        type: LAYOUTS.MODAL,
        style: _isMobile ? {
            height: heightMap[ROUTE.EMPANEL_SUCCESS_MODAL],
            isPartnerPlatform: true,
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.CENTER,
        },
        widgets: [{ id: 'empanelSuccessContainer', type: WIDGET.STACK }],
    },
    datastore: {
        empanelSuccessContainer: {
            type: StackType.column,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            padding: {
                left: SizeTypeTokens.XXL,
                right: SizeTypeTokens.XXL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            widgetItems: [
                { id: 'successIcon', type: WIDGET.ICON },
                { id: 'empanelSuccessSpace0', type: WIDGET.SPACE },
                { id: 'empanelSuccessT1', type: WIDGET.TEXT },
                { id: 'empanelSuccessSpace1', type: WIDGET.SPACE },
                { id: 'empanelSuccessT2', type: WIDGET.TEXT },
                { id: 'empanelSuccessSpace2', type: WIDGET.SPACE },
                { id: 'empanelSuccessT3', type: WIDGET.TEXT },
                { id: 'empanelSuccessSpace3', type: WIDGET.SPACE },
                { id: 'empanelSuccessDivider0', type: WIDGET.DIVIDER },
                { id: 'empanelSuccessSpace4', type: WIDGET.SPACE },
                { id: 'empanelSuccessT4Stack', type: WIDGET.STACK },
                { id: 'empanelSuccessSpace5', type: WIDGET.SPACE },
                { id: 'empanelSuccessT5Stack', type: WIDGET.STACK },
                { id: 'empanelBenefitGetStartedButton', type: WIDGET.BUTTON }
            ],
        },
        empanelSuccessT5Stack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'empanelBenefit', type: WIDGET.PARTNER_BENEFIT },
            ]
        },
        successIcon: {
            name: IconTokens.Success,
            size: IconSizeTokens.XXXXXXXL,
        },
        empanelSuccessT4Stack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'empanelSuccessT4', type: WIDGET.TEXT },
            ]
        },
        empanelSuccessT1: {
            label: `Congratulations!`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
            lineHeight: 26,
        },
        empanelSuccessT2: {
            label: `You've successfully empanelled 🎉`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20,
        },
        empanelSuccessT3: {
            label: `Partner ID: ${refCode}`,
            fontWeight: '700',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        empanelSuccessT4: {
            label: `Get started with Volt Money`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 18,
        },
        empanelBenefit: {
            data: [
                {
                    id: '1',
                    title: 'Register customers',
                    subTitle: 'Help your customers retain their investments',
                },
                {
                    id: '2',
                    title: 'Track customers & earnings',
                    subTitle: 'Track your customer activities easily anytime',
                },
                !isPartnerAffiliated(partnerAccountType) ? {
                    id: '3',
                    title: 'Access co-branded collaterals',
                    subTitle: 'Create your unique brand identity with us',
                } : {
                    id: '3',
                    title: 'Access marketing collaterals',
                    subTitle: 'Create your unique brand identity with us',
                },
            ],
            type: PartnerBenefitCardType.SUCCESS_EMPANEL,
        },
        empanelSuccessDivider0: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Chalk,
        },
        empanelBenefitGetStartedButton: {
            type: ButtonTypeTokens.LargeFilled,
            label: 'Get started',
            width: ButtonWidthTypeToken.FULL,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: SizeTypeTokens.XXL,
            fontWeight: '700',
            action: {
                type: ACTION.GET_STARTED,
                routeId: ROUTE.EMPANEL_SUCCESS_MODAL,
                payload: {
                    referredPartner: referredPartner
                }
            }
        },
        empanelSuccessSpace0: {
            size: SizeTypeTokens.SM,
        },
        empanelSuccessSpace1: {
            size: SizeTypeTokens.SM,
        },
        empanelSuccessSpace2: {
            size: SizeTypeTokens.SM,
        },
        empanelSuccessSpace3: {
            size: SizeTypeTokens.XXXL,
        },
        empanelSuccessSpace4: {
            size: SizeTypeTokens.XXXL,
        },
        empanelSuccessSpace5: {
            size: SizeTypeTokens.XL,
        },
    },
});
export const EmpanelSuccessMF = {
    onLoad: async ({ ...props }, { referredPartner }) => {
        await setAppHeader();
        const user = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
        const refCode = user?.linkedPartnerAccounts[0]?.partnerCode ? user?.linkedPartnerAccounts[0]?.partnerCode : '';
        const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
        return Promise.resolve(template(refCode, referredPartner, partnerAccountType));
    },
    actions: {
        [ACTION.GET_STARTED]: getStartedAction
    },
};
